<template>
	<div>
		<div class="app-container" v-show="isShow">
			<div class="search-box">
				<div class="search-item">
					<label>订单编号：</label>
					<a-input placeholder="请输入" v-model="searchTerm.orderNum" />
				</div>
				<div class="search-item">
					<label>商品名称：</label>
					<a-input placeholder="请输入" v-model="searchTerm.mdseName" />
				</div>
				<div class="search-item" v-show="settlement.orderTab==4" style="position: relative;">
					<label>退款退货状态：</label>
					<a-select   v-model="searchTerm.orderStatus" placeholder="请选择" allowClear @change="selectChange"
					:getPopupContainer=" triggerNode => { return triggerNode.parentNode || document.body;}" >
						<a-select-option :value="40">
							供应商待收货
						</a-select-option>
						<a-select-option :value="45">
							已完成
						</a-select-option>
					</a-select>
				</div>
				<div class="search-item" v-show="settlement.orderTab==5" style="position: relative;">
					<label>换货状态：</label>
					<a-select   v-model="searchTerm.orderStatus" placeholder="请选择" allowClear style="position: relative;" @change="selectChange"
					:getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}">
						<a-select-option :value="50">
							供应商待收货
						</a-select-option>
						<a-select-option :value="52">
							供应商待发货
						</a-select-option>
						<a-select-option :value="54">
							供应商已发货
						</a-select-option>
						<a-select-option :value="56">
							已完成
						</a-select-option>
					</a-select>
				</div>
				<br>
				<div class="search-item">
					<label>供应商账号名：</label>
					<a-input placeholder="请输入" v-model="searchTerm.supplierAlias" />
				</div>
				<div class="search-item">
					<label>渠道商账号名：</label>
					<a-input placeholder="请输入" v-model="searchTerm.distributorAlias" />
				</div>
				<br>
				<div class="search-item">
					<label>是否授信：</label>
					<a-select  v-model="searchTerm.creditStatus" placeholder="请选择" allowClear>
						<a-select-option value="1" >非授信</a-select-option>
						<a-select-option value="2" >授信</a-select-option>
						<a-select-option value="3" >部分授信</a-select-option>
					</a-select>
				</div>
				<div class="search-item">
						<label>创建时间：</label>
						<a-range-picker @change="onChange"   v-model="searchTerm.date" :placeholder="['开始日期', '结束日期']" :getCalendarContainer="
							triggerNode => {
								return triggerNode.parentNode || document.body;
							}
						">
								<a-icon type="clock-circle" slot="suffixIcon"/>
						</a-range-picker>
				</div>
				<div class="search-btn">
					<a-button @click="reset">重置</a-button>
					<a-button type="primary"  @click="search">查询</a-button>
				</div>
			</div>
			<div>
				<a-tabs type="card" v-model="settlement.orderTab"  @change="callback">
					<a-tab-pane key="0" tab="全部"/>
					<a-tab-pane key="1" tab="待发货" />
					<a-tab-pane key="2" tab="已发货"/>
					<a-tab-pane key="3" tab="已完成"/>
					<a-tab-pane key="4" tab="退货退款"/>
					<a-tab-pane key="5" tab="换货"/>
				</a-tabs>
				<order-list :data="data" :pagination="pagination" orderType="1"></order-list>
			</div>
		</div>
		<keep-alive>
			<router-view/>
		</keep-alive>
	</div>
	
</template>
<script>
import {mapState} from 'vuex'
import page from "@/assets/mixin/page.js";
import moment from "moment";
import "moment/locale/zh-cn";
import OrderList from "@/components/OrderList";
export default {
	mixins: [page],
	components:{OrderList},
	data() {
		return {
			data:[],
			searchTerm:{
				orderStatus:undefined
			},
			pagination: {
				total:0,
				current:1,
				pageSize:10,
				onChange: page => {
					this.pagination.current = page;
					this.getdata && this.getdata();
				},
			},
		};
	},
   computed: {
		 ...mapState(['settlement',]),
    isShow() {
      return this.$route.name === "order-manage";
    },
	 },
	created(){
		this.settlement.orderTab = "0";
		this.pagination.current = 1;
		this.callback(this.settlement.orderTab)
	},
	methods:{ 
		disabledDate(current) {
      return current && current > moment().endOf('day');
    },
    onChange(date){
    },
		callback(key) {
			this.pagination.current = 1;
			this.searchTerm.orderStatus = undefined;
			const orderStatusList = [[],[10],[20],[30],[40,45],[50,52,54,56]];
			this.searchTerm.orderStatusSet = orderStatusList[key];
			this.getdata()
		},
		reset(){
			this.searchTerm = {
				orderStatus:undefined
			};
			if (this.settlement.orderTab) {
				this.callback(this.settlement.orderTab)
			}
		},
		selectChange(){
			this.$forceUpdate();
		},
		search(){
			this.pagination.current= 1;
			this.getdata();
		},
		getdata(){
			let {date,orderStatusSet,orderStatus,... params} = this.searchTerm;
			if (date&&date.length>0) {
				params.startDate = date[0].format('YYYY-MM-DD');  
				params.endDate   = date[1].format('YYYY-MM-DD');  
			}
			if (orderStatus) {
				params.orderStatusSet = [orderStatus]
			}else{
				params.orderStatusSet = orderStatusSet;
			}
			params.pageNum = this.pagination.current;
			this.$http.post('order/queryRecordList',params).then(res=>{
				this.data = res.rows
				this.pagination.total = res.count;
			})
		},
	}
};
</script>
<style lang="less" scoped>
.app-container{
	background-color: #fff;
	padding: 24px;
	margin: 0 24px 24px 24px;
}
.search-box{
	label{
		display:inline-block;
		width: 98px;
		text-align: right;
	}
	.search-btn{
		margin-left: 98px;
	}
	
}
</style>
